// ── URL immagini Figma - Pagina Domande Frequenti ────────────────────────

export const DOMANDE_FREQUENTI_IMAGES = {
  // Header e layout principali
  header: '/images/062032ef-97dc-441b-8b73-8e179af8e316.png',
  graphic: '/images/8c97b7d9-2361-4e2a-bd56-40669213e28b.svg',
  group3: '/images/8f419008-1266-41b8-ae21-9d8976ccfb48.svg',
  arrow2: '/images/bbea6910-15df-420c-bd16-fb9c1c1b715c.svg',

  // Pulsanti e icone CTA
  vector: '/images/de479f4b-d135-4100-9ee0-67a3cccddf82.svg',
  group: '/images/465b1ec6-59d0-44dd-bbd2-213688fe78e7.svg',

  // Contatti footer
  phone: '/images/a946f7d4-c76d-41f6-8189-c9764e52cabb.svg',
  envelopeSimple: '/images/23c5fd6d-a8d1-4224-8eab-b3bca8b26389.svg',
  mapPin: '/images/10fcf595-d4da-418a-92e8-99987bb58dc3.svg',

  // Icone social footer
  icon10: '/images/f3f89a73-5318-4176-ad26-111fa37a9765.svg',
  icon11: '/images/d806d916-7ca4-4b4e-af33-6e77926e6fd2.svg',
  icon12: '/images/46f7264a-0868-4c11-b16d-e0f0faecac73.svg',
  icon13: '/images/33075ff0-d0df-4320-96b1-23beb596191a.svg',

  // Icone FAQ
  faqIcon0: '/images/23d36a5b-4727-4b71-80df-4bdfda1facc2.svg',
  faqIcon1: '/images/c901c031-553e-45fa-9d70-af8ba5f0a967.svg',
  faqIcon2: '/images/19e18e17-e7a5-4d5c-9add-b4444144ec68.svg',
  faqIcon3: '/images/e3ce82b1-e030-44d1-8ab8-2b23a92b7560.svg',
};
